<template>
    <b-dropdown
        v-b-tooltip.hover
        :value="skipFramesAmount"
        variant="dark2"
        class="time-skip-amount-handler mr-1"
        :title="$translate('skip_by')"
        :text="formatMinutesItem(delayBetweenCycles_m * skipFramesAmount)"
        :boundary="boundary"
    >
        <b-dropdown-item
            v-for="amount in amountOptions"
            :key="amount"
            href="#"
            @click="frameSkipAmountChangeHandler(amount)"
        >
            {{ formatMinutesItem(delayBetweenCycles_m * amount) }}
        </b-dropdown-item>
    </b-dropdown>
</template>

<script>
export default {
    name: 'TimeSkipAmountHandler',
    props: {
        skipFramesAmount: {
            type: Number,
            required: true
        },
        // eslint-disable-next-line vue/prop-name-casing
        delayBetweenCycles_m: {
            type: Number,
            required: true
        },
        // ref : https://bootstrap-vue.org/docs/components/dropdown#boundary-constraint
        boundary: {
            type: String,
            default: 'scrollParent'
        }
    },
    data: () => ({
        amountOptions: [1, 2, 5, 10]
    }),
    methods: {
        frameSkipAmountChangeHandler(amount) {
            this.$emit('skipFramesAmountChanged', amount)
        },
        formatMinutesItem(value) {
            if (value > 60) {
                return this.$translate('x_hours', (value / 60).toFixed(2))
            }

            return this.$translate('x_min', value)
        }
    }
}
</script>
